<template>
  <div class="margin-top">
    <div class="label-input margin-top-half">
      {{ $t('RequestDate') }}
    </div>
    <div class="marginTop5 recepDate">
      <f7-input
        class="shadow"
        type="datepicker"
        :placeholder="$t('RequestDate')"
        :clear-button="true"
        :close-on-select="true"
        :value="calculatedRequestDate"
        :calendar-params="{
          closeOnSelect: true,
          rangePicker: true,
          dateFormat: {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric',
          },
          disabled: isDisabled,
        }"
        @calendar:change="setRequestDate"
      />
    </div>
    <div class="marginTop15">
      <div>{{ $t('status') }}</div>

      <DxTagBox
        :data-source="materialStates"
        :multiline="true"
        :search-enabled="true"
        :placeholder="$t('status')"
        tag-template="tag"
        :value="selectedStatuses"
        value-expr="id"
        :display-expr="displayStatus"
        :on-value-changed="statusesChanged"
        :on-opened="ensureFilterOptions"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <!-- Item en el dropdown -->
        <template #item="{ data }">
          {{ displayStatus(data) }}
        </template>

        <!-- Tag seleccionado -->
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ displayStatus(data) }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>

    <!-- Este va a ser el tipo de entrega-->
    <div class="marginTop15">
      <div>
        {{ $t('deliveryType') }}
      </div>
      <DxTagBox
        :data-source="materialDeliveryTypes"
        :multiline="true"
        :search-enabled="true"
        :placeholder="$t('deliveryType')"
        tag-template="tag"
        :value="selectedDeliveryTypes"
        :display-expr="displayDeliveryType"
        value-expr="id"
        :on-value-changed="deliveryTypesChanged"
        :on-opened="ensureFilterOptions"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <template #item="{ data }">
          {{ displayDeliveryType(data) }}
        </template>
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ displayDeliveryType(data) }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>
  </div>
</template>

<script>
import { DxTagBox } from 'devextreme-vue/tag-box';
import { mapActions, mapState } from 'vuex';
import { AFTER_DATE_LIMIT } from '@/js/constants';
import moment from 'moment';

export default {
  components: {
    DxTagBox,
  },
  data() {
    return {};
  },

  computed: {
    calculatedRequestDate() {
      if (
        this.requestFromDate !== null &&
        this.requestToDate !== null
      ) {
        return [this.requestFromDate, this.requestToDate];
      }
      return [];
    },
    selectedStatuses: {
      get() {
        return this.$store.state.materialRequestFilters
          .selectedStatuses;
      },
      set(value) {
        this.setSelectedStatuses(value);
      },
    },
    selectedDeliveryTypes: {
      get() {
        return this.$store.state.materialRequestFilters.tipoEnvio;
      },
      set(value) {
        this.setTipoEnvio(value);
      },
    },
    ...mapState('materialRequestFilters', [
      'requestToDate',
      'requestFromDate',
      'materialStates',
      'materialDeliveryTypes',
      'materialOptionsLoading',
    ]),
  },

  mounted() {
    this.fetchMaterialFilterOptions();
  },

  methods: {
    getTranslationKey(value) {
      const match = String(value || '').match(/^\$t\((.+)\)$/);
      if (!match) return null;
      return match[1].trim().replace(/^['"]|['"]$/g, '');
    },
    getTranslatedBackendText(value, fallback = '') {
      const translationKey = this.getTranslationKey(value);
      return translationKey
        ? this.$t(translationKey)
        : fallback || value || '';
    },
    findOptionById(options, id) {
      return options.find(
        (option) => String(option.id) === String(id)
      );
    },
    displayStatus(item) {
      if (!item) return '';
      const option =
        typeof item === 'object'
          ? item
          : this.findOptionById(this.materialStates, item);
      if (!option) return '';
      return this.getTranslatedBackendText(
        option.descripcion,
        option.state
      );
    },
    displayDeliveryType(item) {
      if (!item) return '';
      const option =
        typeof item === 'object'
          ? item
          : this.findOptionById(this.materialDeliveryTypes, item);
      if (!option) return '';
      return this.getTranslatedBackendText(
        option.description,
        option.type
      );
    },
    isDisabled(date) {
      return (
        moment(date).isBefore(moment(AFTER_DATE_LIMIT), 'day') ||
        moment(date).isAfter(moment(), 'day')
      );
    },
    setRequestDate(e) {
      if (e.length === 2) {
        this.setRequestFromDate(e[0]);
        this.setRequestToDate(e[1]);
      } else if (e.length === 0) {
        this.setRequestFromDate(null);
        this.setRequestToDate(null);
      }
    },
    ensureFilterOptions() {
      this.fetchMaterialFilterOptions();
    },
    statusesChanged(e) {
      const SelectedStatuses = e.value;
      this.setSelectedStatuses(SelectedStatuses);
    },
    deliveryTypesChanged(e) {
      const selectedDeliveryTypes = e.value;
      this.setTipoEnvio(selectedDeliveryTypes);
    },
    contentReady() {
      const arrayNotFoundItems = Array.from(
        document.getElementsByClassName('dx-empty-message')
      );

      arrayNotFoundItems.forEach((element) => {
        if (this.materialOptionsLoading) {
          element.innerHTML = this.$t('loading');
        } else {
          element.innerHTML = this.$t('dataNotAvailable');
        }
      });
    },
    ...mapActions('materialRequestFilters', [
      'setRequestToDate',
      'setRequestFromDate',
      'setSelectedStatuses',
      'setTipoEnvio',
      'fetchMaterialFilterOptions',
    ]),
  },
};
</script>
